/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KioskMaintenanceDto } from '../../models/kiosk-maintenance-dto';

export interface MaintenanceCheckInsurerMaintenance$Params {
  insurerId?: string;
  isKiosk?: boolean;
}

export function maintenanceCheckInsurerMaintenance(http: HttpClient, rootUrl: string, params?: MaintenanceCheckInsurerMaintenance$Params, context?: HttpContext): Observable<StrictHttpResponse<KioskMaintenanceDto>> {
  const rb = new RequestBuilder(rootUrl, maintenanceCheckInsurerMaintenance.PATH, 'get');
  if (params) {
    rb.query('insurerId', params.insurerId, {});
    rb.query('isKiosk', params.isKiosk, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<KioskMaintenanceDto>;
    })
  );
}

maintenanceCheckInsurerMaintenance.PATH = '/v1/Maintenance/CheckInsurerMaintenance';
